module.exports = __webpack_public_path__ + "img/ic_partner.a2e60086.png";